import { getCognitoAccessToken } from './user.service';
import { cdnApiClient } from './cdnApiClient';
import { cdnApiPath } from './cdnApiPaths';
import storageService from './storage.service';
import { LOCALSTORAGE_ACKNOWLEDGEMENTS_KEY } from '../utils/announcements';

export const getAnnouncements = () => cdnApiClient.request(
  cdnApiPath(`announcements?nestOrganizationId=${process.env.REACT_APP_NEST_ORGANIZATION_ID}&platform=web`),
);

export const acknowledgeAnnouncement = async (announcementId) => {
  // Get array of acknowledged announcement IDs from local storage. If one doesn't yet exist, initialize to empty array.
  const acknowledgedAnnouncementIds = storageService.getItem(LOCALSTORAGE_ACKNOWLEDGEMENTS_KEY) || [];
  if (!acknowledgedAnnouncementIds.includes(announcementId)) {
    acknowledgedAnnouncementIds.push(announcementId);
  }

  storageService.setItem(LOCALSTORAGE_ACKNOWLEDGEMENTS_KEY, acknowledgedAnnouncementIds);

  const accessToken = await getCognitoAccessToken();
  if (!accessToken) {
    // unauthenticated user — /announcements/{id}/acknowledge requires auth, so only the
    // local acknowledgement above applies. useMutation expects a Promise returned.
    return Promise.resolve();
  }

  return cdnApiClient.request(
    cdnApiPath(`announcements/${announcementId}/acknowledge`),
    { method: 'POST' },
  );
};
